require('bootstrap/dist/js/bootstrap.min')
require('bootstrap/dist/css/bootstrap.min.css')
require('normalize.css/normalize.css');
require('./styles/style.css');

window.addEventListener('load', () => {
    setTimeout(() => {
        document.body.style.display = 'block';
    });
});